export default __webpack_public_path__ + "static/media/Ferony-300.2adbda80.jpg";